import React from 'react';
import classNames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';

interface IConditionalFormatListItemProps {
  index: number;
  typeLabel: string;
  metricName?: string;
  onDelete: () => void;
}

const ConditionalFormatListItem: React.FC<IConditionalFormatListItemProps> = ({
  index,
  typeLabel,
  metricName,
  onDelete,
}) => {
  const displayName = metricName ?? '';

  return (
    <div className="dbl-chart-conditional-format-list-item">
      <div className="dbl-chart-conditional-format-list-item-label">
        <span className="dbl-chart-conditional-format-list-item-label-strong">
          {index}
        </span>
        <span className="dbl-chart-conditional-format-list-item-label-strong">
          {typeLabel}
        </span>
        <span
          className={classNames(
            'dbl-chart-conditional-format-list-item-label-text',
            'dbl-text-ellipsis',
          )}
          title={displayName}
        >
          {displayName}
        </span>
      </div>
      <div
        className="dbl-chart-conditional-format-list-item-controls"
        onClick={onDelete}
      >
        <SvgIcon type="delete-icon" />
      </div>
    </div>
  );
};

const MemoConditionalFormatListItem = React.memo(ConditionalFormatListItem);
MemoConditionalFormatListItem.displayName = 'ConditionalFormatListItem';

export default MemoConditionalFormatListItem;
